// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9509) return "static/chunks/6f31d389-adaba45f3d43f19c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1805":"25f4ac2a","2440":"datadogProfiler","3581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"620":"078aabb23e1f5b92","1805":"30dc3b0963889998","2440":"86c06de994d42f45","3112":"4f184c4414b87004","3581":"a1151c84284afa4e","4469":"1c9b5e5d4199082a","6532":"d6f5cc4e3138deb3","8436":"cab94b59cca0a8ff"}[chunkId] + ".js";
};